import React from 'react';
import Radio from '../../../../components/Radio';
import { t } from '../../../../utilities/translator';
import abTesting from '../../../../services/abTesting';

const TypeSwitcher = ({
  type,
  onChange
}) => {
  return (
    <div className="dates-filter__type">
      {abTesting.hideDateTutorial &&
        <Radio
          id="specificDates"
          key="specific"
          label={t('mainFilter.specific_dates')}
          checked={type === 'specific'}
          value="specific"
          onChange={() => onChange('specific')}
        />
      }
      <Radio
        key="months"
        label={t('mainFilter.whole_month')}
        checked={type === 'month'}
        value="month"
        onChange={() => onChange('month')}
      />

      <Radio
        key="range"
        label={t('mainFilter.date_range')}
        checked={type === 'range'}
        value="range"
        onChange={() => onChange('range')}
      />
      {!abTesting.hideDateTutorial &&
        <Radio
          id="specificDates"
          key="specific"
          label={t('mainFilter.specific_dates')}
          checked={type === 'specific'}
          value="specific"
          onChange={() => onChange('specific')}
        />
      }
    </div>
  )
}

export default TypeSwitcher;
